import { Reveal } from "./Reveal";
import { Award } from "lucide-react";

const MILESTONES = [
  {
    num: "01",
    title: "European Innovation Academy",
    meta: "Summer Program · Porto · 2026",
    badge: "Selected",
    desc: "Selected for the European Innovation Academy’s Summer Program in Porto, an international entrepreneurship program focused on innovation, startup development, and turning ideas into real-world ventures.",
    testid: "milestone-eia",
  },
  {
    num: "02",
    title: "BioPay",
    meta: "Founder & Developer",
    desc: "Exploring a biometric payments and digital wallet concept focused initially on campus environments, with an emphasis on product feasibility, technical development, and working toward an MVP.",
    testid: "milestone-biopay",
  },
  {
    num: "03",
    title: "Atmospheric Water Generator",
    meta: "Independent Engineering",
    desc: "Experimenting with atmospheric water collection through condensation and exploring the engineering principles behind cooling, heat transfer, and practical device design.",
    testid: "milestone-awg",
  },
  {
    num: "04",
    title: "Competitive Football",
    meta: "State-Level & Zonal Tournaments",
    desc: "Participated in state-level football tournaments three times and zonal football tournaments four times.",
    testid: "milestone-football",
  },
];

export const Milestones = () => (
  <section id="milestones" data-testid="milestones-section" className="py-24 md:py-32 lg:py-40 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#71717A] font-mono-alt">Experience & Achievements</p>
        <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight font-medium text-[#F9F9F9] mt-4">
          Milestones along the way.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-24 relative">
        <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-white/10" aria-hidden="true" />
        <div className="space-y-14 md:space-y-20">
          {MILESTONES.map((m, i) => (
            <Reveal key={m.num} delay={i * 0.06}>
              <div data-testid={m.testid} className="relative pl-10 md:pl-16 grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-8">
                <span
                  className={`absolute left-0 top-1.5 h-[15px] w-[15px] md:h-[19px] md:w-[19px] rounded-full border-2 ${
                    m.badge ? "border-[#0EA5E9] bg-[#0EA5E9]/20" : "border-white/20 bg-[#080808]"
                  }`}
                  aria-hidden="true"
                />
                <div className="md:col-span-4">
                  <p className="font-mono-alt text-xs text-[#71717A]">{m.num}</p>
                  <h3 className="font-heading text-xl md:text-2xl font-medium text-[#F9F9F9] mt-1">{m.title}</h3>
                  <p className="text-xs uppercase tracking-[0.15em] text-[#71717A] mt-2">{m.meta}</p>
                  {m.badge && (
                    <span className="mt-3 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.12em] text-[#0EA5E9] border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 rounded-full px-3 py-1">
                      <Award size={12} /> {m.badge}
                    </span>
                  )}
                </div>
                <p className="md:col-span-7 md:col-start-6 text-sm md:text-base text-[#A1A1AA] leading-relaxed">
                  {m.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
